import { useBulkUnlockStack } from "shared/Stack/useUnlockStack";
import useCanUnlockStack from "shared/Stack/access/useCanUnlockStack";

import { StackBulkActions } from "../types";
import { BULK_ACTION_NAMES, BULK_ACTION_RESULTS_TITLE } from "../constants";
import { StackActionItemForBulkActions } from "./types";

const useUnlockBulkAction = (): StackActionItemForBulkActions => {
  const [stackUnlock] = useBulkUnlockStack();

  const canUnlockStack = useCanUnlockStack();

  return {
    key: StackBulkActions.Unlock,
    title: BULK_ACTION_NAMES[StackBulkActions.Unlock],
    resultTitle: BULK_ACTION_RESULTS_TITLE[StackBulkActions.Unlock],
    condition: (stack) => canUnlockStack(stack),
    mutation: (stack) => stackUnlock({ id: stack.id }),
  };
};

export default useUnlockBulkAction;
